import React from "react";
import { Route, Switch, useRouteMatch, useHistory } from "react-router-dom";

import withAuthorization from "../../auth/withAuthorization";
import { creatorRoles } from "../../auth/authUtils";

import ModuleBrowser from "./browse/ModuleBrowser";
import ModuleEdit from "./edit/ModuleEdit";

// TODO: refactor edit dialog routing
// Setting withAuthorization to false to not show unauthorized screen because
// unauthorized screen flashes when navigating to and away from edit screen for non-Admin users
const AuthorizedRoute = withAuthorization(Route, false);
const ModuleAdminView = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const handleCancel = () => history.goBack();
  return (
    <Switch>
      <AuthorizedRoute exact path={`${path}`} roles={["ROLE_ADMIN"]}>
        <ModuleBrowser view="admin" />
      </AuthorizedRoute>
      <AuthorizedRoute path={`${path}/:id`} roles={creatorRoles}>
        <ModuleEdit view="admin" onCancel={handleCancel} />
      </AuthorizedRoute>
    </Switch>
  );
};

export default ModuleAdminView;
